// @ts-strict-ignore
export const stripTags = (str) => {
  if (str === null || str === '') return false;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line no-param-reassign
  str = str.toString();
  return str.replace(/<[^>]*>/g, ' ');
};
